import {FocusMonitor} from '@angular/cdk/a11y';
import {coerceBooleanProperty} from '@angular/cdk/coercion';
import {Component, ElementRef, Input, OnDestroy, Optional, Self} from '@angular/core';
import {FormBuilder, FormGroup, ControlValueAccessor, NgControl} from '@angular/forms';
import {MatFormFieldControl} from '@angular/material/form-field';
import {Subject} from 'rxjs';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TypeExpertiseService } from '../../shared/services/type-expertise.service';

/** Data structure for holding telephone number. */
export class TypeExpertise {
  constructor(public id: number, public name: string) {}
}

/** Custom `MatFormFieldControl` for telephone number input. */
@Component({
  selector: 'app-type-expertise-input',
  templateUrl: 'type-expertise-input.component.html',
  styleUrls: ['type-expertise-input.component.scss'],
   providers: [        
   		TypeExpertiseService,
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: TypeExpertiseInputComponent,
            multi: true,
        }
    ]  

})
export class TypeExpertiseInputComponent implements ControlValueAccessor {

	@Input() placeholder: string;
	@Input() errors: string;

	id: number;
	types: any[] = [];

	constructor(
		private typeExpertiseService: TypeExpertiseService
	) { }
 
  	propagateChange = (_: any) => {};
  	
  	ngOnInit() {
  		this.typeExpertiseService.get().subscribe(t => this.types = t);
  	}

  	onChange(event) {
  		console.log(event);
  		this.propagateChange(event.value);
  	}

    writeValue(obj: any): void {
    	this.id = obj ? obj.id : null;
    	
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
        this.propagateChange(this.id);
    }

    registerOnTouched(fn: any): void { }

    setDisabledState?(isDisabled: boolean): void { }
}